import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from "environments/environment";
import { QueryResponse } from "app/core/models/query-response";

@Injectable()
export class QueryService {

  constructor(private readonly _httpClient: HttpClient) { }

  public getQueries(filter: string, sortDirection: 'asc' | 'desc'| '', sortField: string, 
                      pageIndex: number, pageSize: number, activeFilters: Object[]): Observable<QueryResponse> {
    
    let allStringFilterAux = [];
    let objectFilter = {};
    activeFilters.forEach((item, index) => {
      if (item['value'] != null && item['value'] != '') {
        objectFilter[item['id']] = item['value'];
      }
    });


    
    let params = new HttpParams()
    .set('page', pageIndex.toString())
    .set('page_size', pageSize.toString())
    .set('sf', sortField?.toString() ? sortField?.toString() : '')
    .set('s', sortField?.toString() ? sortDirection?.toString().toUpperCase() : '');

    return this._httpClient.post(`${environment.apiUrl}/messages/advanced_search`, objectFilter, {
      params: params
      }).pipe(
          map(res =>  <QueryResponse>res)
      );
  }


  getQueryStatus(): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/clusters/status`);
  }

  getDataRawDownload(body: any): Observable <Blob> {
      return this._httpClient.post(`${environment.apiUrl}/messages/advanced_search/download_raw?page=0&page_size=10000`, body, { responseType: 'blob' });
  }    

}
